const TOKEN_KEY = "token";
const USER_KEY = "user";

const hasStorage = () => typeof window !== "undefined" && !!window.localStorage;

const readStorage = (key) => {
  if (!hasStorage()) return "";
  return window.localStorage.getItem(key) || "";
};

export const getToken = () => readStorage(TOKEN_KEY).trim();

export const getUser = () => {
  try {
    const raw = readStorage(USER_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
};

export const clearAuth = () => {
  if (hasStorage()) {
    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.removeItem(USER_KEY);
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event("userChange"));
  }
};

export const setAuthSession = ({ token, user }) => {
  clearAuth();

  if (hasStorage() && token && user) {
    window.localStorage.setItem(TOKEN_KEY, String(token));
    window.localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event("userChange"));
  }
};

const normalizeRole = (value) => String(value || "STUDENT").toUpperCase();

export const normalizeAuthPayload = (payload, fallback = {}) => {
  const token = payload?.token || payload?.accessToken || "";
  const userData = payload?.user || payload || {};

  const user = {
    id: userData?.id ?? userData?.userId ?? fallback?.id ?? null,
    username: userData?.username || fallback?.username || "",
    email:
      userData?.emailId ||
      userData?.email ||
      fallback?.email ||
      "",
    phone: userData?.phone || fallback?.phone || "",
    role: normalizeRole(userData?.role || fallback?.role),
    subscriptionPlan:
      userData?.subscriptionPlan || fallback?.subscriptionPlan || "FREE",
    blocked: Boolean(userData?.blocked ?? fallback?.blocked),
  };

  return { token, user };
};

export const isAuthenticated = () => Boolean(getToken() && getUser());
